import { render, staticRenderFns } from "./LinkColumn.vue?vue&type=template&id=7b067739&scoped=true"
import script from "./LinkColumn.vue?vue&type=script&lang=js"
export * from "./LinkColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b067739",
  null
  
)

export default component.exports